import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Popconfirm, Tabs, Tooltip} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request, {API_URL} from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import {getUrlPushWrapper} from '../../../routes'
import {hideLoader, showLoader} from '../../../modules/actions'
import {RightsWrapper} from '../../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class AllSearchLogs extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    userGroupsArr: []
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({exportParams: params})
      if (!params.sortField) {
        params.sortField = 'callInitiatedBy.time'
        params.sortOrder = 'descend'
      }
      let data = await Request.getAllIVRCallLogs({
        ...params,
        regExFilters: []
      })
      this.setState({total: data.total})
      resolve(data)
    })
  }
  handleSubmit = e => {
    const {dispatch, form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = await Request.searchCallLogs(values)

        if (!x.error) {
          this.setState({
            id: '',
            activeTab: '0',
          })
          notification.success({
            message: 'Call Logs Syncing in progress started in background'
          })
          form.resetFields()
          if (this.table && this.table.current) {
            this.table.current.reload()
          }
        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }
  
  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

  componentWillMount() {
    
  }

  async componentDidMount() {
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
        activeTab: value
    })
  }
  render() {
    const {dispatch} = this.props
    const {
      form: {getFieldDecorator, setFieldsValue}
    } = this.props
    const {id} = this.state;

    const inputTypes = {
      fields: [
        {
          label: 'Date',
          key: 'date',
          type: 'date',
          required: true
        }
      ]
    };
    
    const columns = [
      {
        title: 'Call ID',
        key: 'callerId',
      },
      {
        title: 'Client Number',
        key: 'callerNumber',
      },
      {
        title: 'Agent Number',
        key: 'callerFromNumber',
      },
      {
        title: 'Start Time',
        key: 'startTime',
        render: (text, record) => {
          var startTime = new Date(record.startTime * 1000);
          return (
            <div>
              {
                record.startTime ? 
                  <div>{moment(startTime).format('lll')}</div>
                : 'NA'
              }              
            </div>
          )
        }
      },
      {
        title: 'End Time',
        key: 'endTime',
        render: (text, record) => {
          var endTime = new Date(record.endTime * 1000);
          return (
            <div>
              {
                record.endTime ? 
                  <div>{moment(endTime).format('lll')}</div>
                :'NA'
              }              
            </div>
          )
        }
      },
      {
        title: 'Log Message',
        key: 'logMessage',
        width: '300px'
      },
      {
        title: 'Duration',
        key: 'duration',
      },
      {
        title: 'File',
        key: 'filePath',
        render: (text, record) => {
          return (
            <div>
              {
                record.filePath ?
                  <div><a target="_blank" href={record.filePath}>View</a></div>
                :'NA'
              }              
            </div>
          )
        }
      },
      {
        title: 'call Initiated By',
        key: 'callInitiatedBy',
        dataIndex: 'callInitiatedBy',
        render: (text, record) => {
          return (
            <div>
              <div>{record.callInitiatedBy != null ? record.callInitiatedBy.name : ""}</div>
              <small>{record.callInitiatedBy ? moment(record.callInitiatedBy.time).format('lll') : '' }</small>
            </div>
          )
        }
      },
      {
        title: 'Updated By',
        key: 'lastUpdatedByName',
        dataIndex: 'lastUpdatedByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : '' }</small>
            </div>
          )
        }
      }
    ];
    return (
      <PageHeaderWrapper title={` Search Logs `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Logs`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{scroll: {x: 900}}}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>            
            <TabPane tab={'Search Log'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  Search
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllSearchLogs
